import { ReactElement } from 'react';
import { FieldsProps } from './types';

import { TextField } from '@ff-it/form';
import { FIELD_MAP } from './Fields';
import { CommonFields } from './CommonFields';
import { AttachmentField } from 'modules/attachments/AttachmentField';

export function BriefFields(props: FieldsProps): ReactElement {
  const Fields = FIELD_MAP[props.type];
  return (
    <>
      <CommonFields {...props} />
      {props.type !== 'SEO' && (
        <TextField
          name="suggested_media"
          label="Suggested media"
          help={props.type === 'CREATIVE' ? 'For which channels materials will be used for' : undefined}
        />
      )}
      <TextField name="comment" label="Comment" multiline />

      {Fields && <Fields />}

      <AttachmentField name="brief_attachments" label="Attachements" />
    </>
  );
}
